import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useChargesFilteringV2Enabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.ChargesFilteringV2,
    false
  );

  return Boolean(isEnabled);
}
